import Cards, { CardVideo, MoreButton } from './Cards'
import React, { useEffect, useState } from 'react'
import { SendRequest, constants } from 'cng-web-lib'

import { ArticleCategory as Category } from 'src/constants'
import { EssenceApiUrls as Url } from 'src/apiUrls'
import pathMap from 'src/paths/pathMap'

const { AxiosMethod } = constants

function VideosSection() {
  const VIDEOS_PATH = `${pathMap.HOME}/${Category.VIDEO}`
  const [data, setData] = useState([])

  useEffect(() => {
    const getRequest = sendGetRequest()

    return () => {
      getRequest.abort()
    }
  }, [])

  function sendGetRequest() {
    const sendRequest = new SendRequest()
    sendRequest.execute(AxiosMethod.GET, Url.NEWEST_3_VIDEO, {}, (body) => {
      setData(convertToLocalData(body.data.Data))
    })
    return sendRequest
  }

  function convertToLocalData(remoteData) {
    const data = remoteData.map((remoteDatum) => {
      const detailLink = `${VIDEOS_PATH}/${remoteDatum.Id}`
      return {
        id: remoteDatum.Id,
        title: remoteDatum.Title,
        link: remoteDatum.Body,
        summary: remoteDatum.Summary,
        datetime: remoteDatum.PublishStartDate,
        detailLink,
        playing: false,
        loop: false,
        controls: true
      }
    })
    return data
  }

  return (
    <Cards
      header='Latest Videos'
      data={data}
      renderCardMedia={(video) => {
        return (
          <CardVideo
            url={video.link}
            isPlaying={video.playing}
            shouldLoop={video.loop}
            hasControls={video.controls}
          />
        )
      }}
      renderButtonSection={() => {
        return <MoreButton listUrl={VIDEOS_PATH}>More Videos</MoreButton>
      }}
    />
  )
}

export default VideosSection
